export class AuthorizationFailureError extends Error {
    constructor() {
        super('Authorization cannot be determined.');
        this.name = AuthorizationFailureError.name;
    }
}
